import { moveToPhotoReviewList } from './moveToPhotoReviewList';
import { moveToReviewList } from './moveToReviewList';

export const useReviewsNavigator = () => {
  return { moveToPhotoReviewList, moveToReviewList };
};